<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1>Fırsatlar</h1>
      </div>
      <div class="icerik">
        <el-row :gutter="24">
          <Yukleniyor :data="lo"></Yukleniyor>
          <el-col :span="4" v-for="f in Firsatlar">
            <div class="firsatkutu">
              <img :src="f.Resim.Url+f.Resim.Data">
              <div class="firsatdetay">
                <h5>{{f.Baslik}}</h5>
                <h6>{{f.Aciklama}}</h6>
                <p class="firsatgun">
              <span class="text-success">
                <i class="el-icon-info"></i> {{f.Telefon}}</span>
                </p>
                <h3>{{f.KuponKodu}}</h3>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        ModalOlayi: false,
        Firsatlar: [],
        Detay: null
      }
    },
    methods: {
      KampanyaDetay(detay) {
        this.Detay = detay;
        this.ModalOlayi = true;
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'kilavuz/firsat'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Firsatlar = response.Data;

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Firsat/index.vue